var render, staticRenderFns
import script from "./BasicHelp.vue?vue&type=script&lang=js"
export * from "./BasicHelp.vue?vue&type=script&lang=js"
import style0 from "./BasicHelp.vue?vue&type=style&index=0&id=7461d726&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports